import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "addSensorAlarmComment" }
const _hoisted_2 = { class: "addSensorAlarmComment__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  class: "label-comment",
  for: "sensorAlarmComment"
}
const _hoisted_5 = { class: "addSensorAlarmComment__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModal)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('addAlarmComment')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Close Modal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              })
            ]),
            _createElementVNode("form", {
              id: "sensorAlarmComment-form",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
            }, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('comment')), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "sensorAlarmComment",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.alarmInfo) = $event)),
                class: "input-comment",
                maxlength: "250"
              }, "        ", 512), [
                [_vModelText, _ctx.formData.alarmInfo]
              ])
            ], 32),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('save'),
                onClick: _ctx.save
              }, null, 8, ["title", "onClick"]),
              _createVNode(_component_Button, {
                variant: "bordered",
                title: _ctx.$t('cancel'),
                onClick: _ctx.closeModal
              }, null, 8, ["title", "onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}